var Row = /*@__PURE__*/ (function () {
    function Row() {
        var _this = this;
        this.addCell = function (cell) {
            jQuery(_this.element).append(cell.getElement());
        };
        this.getElement = function () {
            return _this.element;
        };
        this.element = jQuery('<div class="tr"></div>').get(0);
    }
    return Row;
}());
export default Row;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/DatePicker/Row.ts
// module id = null
// module chunks = 